import { isEmpty } from '@ember/utils'
import type { StatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type { NormalizedInterval } from 'date-fns'

export interface BooksReadByLevelResponse {
  books_read_by_level: BooksReadByLevelData[]
}

export interface BooksReadByLevelData {
  range: string
  count: number
}

export async function booksReadByLevel(
  this: StudentEventsService,
  product: LegacyProductRex,
  statsScope: StatsScope,
  period: NormalizedInterval,
): Promise<Nullable<BooksReadByLevelData[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('books_read_by_level', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<BooksReadByLevelResponse>(url, query)
  if (!data) return null

  const { books_read_by_level } = data
  const hasNoCounts = books_read_by_level.every(({ count }) => count === 0)
  if (books_read_by_level.length === 0 || hasNoCounts) return null

  return books_read_by_level
}
